import { type NextBestAction } from '@post-office/confluence-next-best-action';
import {
	type BackendPlacementMessage,
	defaultMessageBackend,
	type FrontendPlacementMessage,
} from '@post-office/placement-common-v2';
import {
	PlacementBackend,
	PlacementFrontend,
} from '@post-office/placements--growth/confluence-side-nav';

import { ResurrectedUserWelcomeMessage } from './message';
import { assertMessageTemplateContext } from '../../../__generated__/validation/messageTemplateContext';
import { type MessageTemplateContext } from '../../../index';
import type {
	CreatePlacementMessageConfig,
	AnyPayload,
} from '@post-office/message-template-contracts/placement-v2';
import {
	type BackendSyncMessageStage,
	type AnyBackendMessageStage,
	type AnyFrontendStage,
} from '@post-office/placement-common-v2/create-placement/types';
import { type TransformMetadataResult } from '@post-office/shared-contracts/message-template-metadata';

// Shouldn't need to change message before sending to frontend
export const MessageBackend: (config: CreatePlacementMessageConfig) => BackendPlacementMessage<{
	transformMetadata: BackendSyncMessageStage<AnyPayload, TransformMetadataResult>;
	hydrate?: AnyBackendMessageStage;
}> = PlacementBackend.createMessageBackend(defaultMessageBackend);

type MessageFrontendProps = MessageTemplateContext & {
	onSideNavClick: (nextBestActionType: NextBestAction) => string | void | null;
	handleOnDismissed: () => void;
};

export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: AnyFrontendStage;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: assertMessageTemplateContext,
		Component: ({
			nextBestActionType,
			onSideNavClick,
			handleOnDismissed,
		}: MessageFrontendProps) => {
			return (
				<ResurrectedUserWelcomeMessage
					onSideNavClick={onSideNavClick}
					handleOnDismissed={handleOnDismissed}
					nextBestActionType={nextBestActionType}
				/>
			);
		},
	},
});
